import { type PutInteractor } from '@coris-ts/repository/interactor/put.interactor'
import { MetaAdsQuery } from '../../data/queries/meta-ads.query'
import { buildMetaEventsBody, type BuildMetaEventParams } from '../helpers/meta-events-builder'

export class MetaAdsInteractor {
  constructor(private readonly putInteractor: PutInteractor<void>) {}

  public async execute(params: BuildMetaEventParams): Promise<void> {
    await this.putInteractor.execute(undefined, new MetaAdsQuery(buildMetaEventsBody(params) as unknown as Record<string, unknown>))
  }
}
